import { Grid2, Typography } from "@mui/material";
import CertificateContainer from "../CertificateContainer";

import classes from './index.module.scss';

const SingleCertificateTypeContainer = ({ type }) => {
  return (
    <Grid2 container>
      <Grid2 size={12}>
        <Typography variant="h3" className={classes.title}>
          {
            type === CertificateContainer.TYPES.APPROVAL ? 'GHMT Type Approval' : 'Monitored products GHMT PREMIUM Verification Program'
          }
        </Typography>
      </Grid2>
      <CertificateContainer type={type} showCompanyLink={type === CertificateContainer.TYPES.PREMIUM} />
    </Grid2>
  )
}

export default SingleCertificateTypeContainer;